const environments = {
  local: {
    // url: 'http://localhost:9158', // set you local url here
    url: 'https://sdeiaiml.com:9159',
    // url: 'https://f7108jl9-8000.inc1.devtunnels.ms/',
  },
  staging: {
    url: 'https://sdeiaiml.com:9157', // Set your staging URL of backend here
  },
  production: {
    url: 'https://api.myswimscore.com', // Production backend API URL
  },
};

// eslint-disable-next-line no-undef
const currentEnv = process.env.REACT_APP_ENV || 'local';
console.log('Current Environment:', currentEnv);

export const apiUrl = environments[currentEnv].url;
